import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c0e46b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  ref: "innerTextBtnRef"
}
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LottieAnimation = _resolveComponent("LottieAnimation")!

  return (_openBlock(), _createElementBlock("a", {
    id: _ctx.id,
    href: "#",
    class: _normalizeClass(`tw-flex  tw-justify-center tw-h-fit tw-pt-[8px] tw-pb-[8px] tw-pr-[20px]
    tw-pl-[20px] tw-rounded-[100px] tw-text-center !tw-text-white !tw-no-underline tw-text-[13px] tw-bg-[#387dff] tw-font-[500] tw-font-[Poppins] button ${
      _ctx.disabled ? 'disabled' : ''
    } ${_ctx.isLoading ? 'tw-cursor-not-allowed !tw-bg-[#387dff]' : ''}`)
  }, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(`${_ctx.subTitle ? 'tw-font-medium' : ''} ${_ctx.cssButton}`)
          }, _toDisplayString(_ctx.title), 3),
          (_ctx.subTitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, ": " + _toDisplayString(_ctx.subTitle), 1))
            : _createCommentVNode("", true)
        ], 512))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({ width: _ctx.animationWidth + 'px' }),
          class: "tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
        }, [
          _createVNode(_component_LottieAnimation, {
            ref: "anim",
            "animation-data": _ctx.progressAnimationDark,
            "auto-play": true,
            loop: true
          }, null, 8, ["animation-data"])
        ], 4))
  ], 10, _hoisted_1))
}